import type { FooterKeyLinks as FooterKeyLinksSchema } from '@amplience/content-types/typings/c-footer-key-links';
import { LinkPartial } from '../../../partials/link';
import { getLocalizedValue } from '../../../utils/transformers';
import { KeyLinkContainer } from './FooterKeyLinkContainer';
import { Container, KeyLink, KeyLinks } from './FooterKeyLinks.styles';

export type FooterKeyLinksProps = FooterKeyLinksSchema;

export function FooterKeyLinks({ footerKeyLinks }: FooterKeyLinksProps) {
  return (
    <Container>
      <KeyLinks>
        {footerKeyLinks?.map((keyLink, idx) => {
          const { link } = keyLink ?? {};

          if (keyLink) {
            return (
              <KeyLink key={idx}>
                <LinkPartial
                  {...link}
                  ariaLabel={[keyLink.title, keyLink.description]
                    .flatMap((value) => (value ? getLocalizedValue(value) : []))
                    .join(', ')}
                >
                  <KeyLinkContainer keyLink={keyLink} />
                </LinkPartial>
              </KeyLink>
            );
          }

          return null;
        })}
      </KeyLinks>
    </Container>
  );
}

export default FooterKeyLinks;
